import type { ComponentPropsWithoutRef } from 'react';
import { AlertIcon } from '#assets/ReactSvg.ts';
import { Tooltip } from '#components/atoms/tooltip/Tooltip.tsx';

const emptyObj = {};

type Props = {
  entityId: string;
  tooltipProps?: Omit<ComponentPropsWithoutRef<typeof Tooltip>, 'content'> & { content?: string };
};

/**
 * In case we can't find the name of an entity (role, route, host, etc), we show a
 * red alert icon and the entity's id, with a tooltip that gives the full id in case
 * there isn't room where the id is being shown.
 */
export function MissingEntity({ entityId, tooltipProps = emptyObj }: Props) {
  const { content = `${entityId} is missing, was it deleted?` } = tooltipProps;

  return (
    <Tooltip className="mw-0 truncate color-error" {...tooltipProps} content={content}>
      <AlertIcon /> {entityId}
    </Tooltip>
  );
}
